import { graphql } from "gatsby";
import React from "react";
import FirstIntroSection from "../../components/careers/firstIntro";
import Layout from "../../components/Layout";
import Hero from "../../components/ourstory/Hero";
import SecondIntro from "../../components/careers/SecondIntro";
import CareerForm from "../../components/careers/CareerForm";
import FeaturedPages from "./../../components/common/featuredPages";
import SEO from "../../components/common/SEO";

const Careers = ({ data }) => {
  const careers = data.contentfulContentPages;

  return (
    <Layout>
      <Hero header={careers.header} />
      <FirstIntroSection
        intro={careers.firstIntro}
        backgroundColor="bg-[#f1f1f1]"
        maxWidth="max-w-[900px]"
      />
      <SecondIntro
        title1={careers?.secondIntroTitle || ""}
        description1={careers.secondIntroDescription}
        title2={careers?.thirdIntroTitle || ""}
        description2={careers?.thirdIntroDescription || ""}
      />
      <CareerForm description={careers?.forthIntro || ""} />
      <FeaturedPages
        title={careers.featuredPagesTitle}
        pages={careers.featuredPages}
      />
    </Layout>
  );
};

export const query = graphql`
  {
    contentfulContentPages(contentful_id: { eq: "2u33fsSjfVDlz9qZrnrHlN" }) {
      seo {
        title
        metaDescription {
          metaDescription
        }
        icon
        logo
      }
      contentful_id
      title
      header {
        breadcrumbName
        title
        description {
          description
        }
        backgroundImage {
          gatsbyImageData(
            layout: FULL_WIDTH
            formats: WEBP
            placeholder: DOMINANT_COLOR
          )
          title
        }
      }
      firstIntro {
        raw
      }
      secondIntroTitle
      secondIntroDescription {
        raw
      }
      thirdIntroTitle
      thirdIntroDescription {
        raw
      }
      forthIntro {
        raw
      }
      featuredPagesTitle
      featuredPages {
        title
        backgroundImage {
          gatsbyImageData(
            layout: FULL_WIDTH
            formats: WEBP
            placeholder: DOMINANT_COLOR
          )
          title
        }
        buttonText
        buttonLink
      }
    }
  }
`;

export function Head({ location, data }) {
  return <SEO location={location} data={data?.contentfulContentPages?.seo} />;
}

export default Careers;
